import { Component, Inject, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/model/project/project';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { RequestService } from 'src/app/services/request.service';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { SnackService } from 'src/app/services/snack.service';
import ProductAsset from 'src/app/model/product-asset';
import { ContactOption } from './contact-option';
import { SubProject } from '../../model/project/sub-project';
import { FileHelper } from '../../helpers/file-helper';

@Component({
  selector: 'send-thank-you-mail',
  templateUrl: './send-thank-you-mail.component.html',
  styleUrls: ['./send-thank-you-mail.component.scss'],
})
export class SendThankYouMailComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  inputSubProject: SubProject;

  @Input()
  inputProject: Project;

  contactOptions: ContactOption[];
  selectedContacts: ContactOption[];

  assetOptions: ProductAsset[];
  selectedAssets: ProductAsset[] = [];
  isImage = FileHelper.isImage;

  init = false;
  sending = false;

  constructor(
    public dialogRef: MatDialogRef<SendThankYouMailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private requestService: RequestService,
    private snackService: SnackService
  ) {
    super();
    this.inputProject = data.project;
    this.inputSubProject = data.subProject;
  }

  ngOnInit() {
    this.loadProject();
  }

  loadProject() {
    this.addSubscription(
      this.requestService.getNormal('/projects/' + this.inputProject.id),
      (res) => {
        this.inputProject = res;
        if (res.subProjects != null) {
          for (let subProject of res.subProjects) {
            if (subProject.id === this.inputSubProject.id) {
              this.inputSubProject = subProject;
              break;
            }
          }
        }
        this.constructEmailOptions();
        this.constructAssetOptions();
        this.init = true;
      }
    );
  }

  constructEmailOptions() {
    this.selectedContacts = [].concat(
      this.inputProject.projectContacts.map((pc) =>
        ContactOption.fromContact(pc.contact, pc.projectManager)
      )
    );
    this.contactOptions = []
      .concat(
        this.inputProject.projectContacts
          .filter(
            (pc) => !this.selectedContacts.some((sc) => sc.id === pc.contact.id)
          )
          .map((pc) =>
            pc.company.contacts.map((c) => ContactOption.fromContact(c, false))
          )
          .reduce(concat, [])
      )
      .concat(this.selectedContacts);
  }

  constructAssetOptions() {
    if (this.inputSubProject.type === 'BaseProject') {
      this.constructAssetOptionsForBaseProject();
    } else if (
      this.inputSubProject.type === 'Adjustment' ||
      this.inputSubProject.type === 'SoldRented'
    ) {
      this.constructAssetOptionsForAdjustment();
    }
  }

  constructAssetOptionsForBaseProject() {
    this.assetOptions = this.inputProject.products
      .map((p) =>
        p.productAssets.filter(
          (pa) => pa.formSection === 'execution' && !pa.archived
        )
      )
      .reduce(concat, []);
    if (this.assetOptions != null && this.assetOptions.length === 1) {
      this.selectedAssets.push(this.assetOptions[0]);
    }
  }

  constructAssetOptionsForAdjustment() {
    this.assetOptions =
      this.inputSubProject.projectPlacement.projectPlacementAssets
        .filter((pa) => !pa.archived)
        .reduce(concat, []);
    if (this.assetOptions != null && this.assetOptions.length === 1) {
      this.selectedAssets.push(this.assetOptions[0]);
    }
  }

  compareEntities(pa1: any, pa2: any) {
    return pa1 != null && pa2 != null && pa1.id === pa2.id;
  }

  assetIsSelected(id: number) {
    return this.selectedAssets.some((a) => a.id === id);
  }

  toggleSelectAsset(productAsset: ProductAsset) {
    let removed = false;

    for (let i = 0; i < this.selectedAssets.length; i++) {
      let option = this.selectedAssets[i];
      if (option.id === productAsset.id) {
        this.selectedAssets.splice(i, 1);
        removed = true;
        break;
      }
    }

    if (!removed) {
      this.selectedAssets.push(productAsset);
    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  sendMail() {
    if (!this.canSendMail()) {
      return;
    }
    let body = {
      contacts: this.selectedContacts.map((c) => c.id),
      productAssets: this.selectedAssets.map((pa) => pa.id),
    };
    this.sending = true;
    this.addSubscription(
      this.requestService.post(
        body,
        '/subprojects/sendThankYouEmail/' + this.inputSubProject.id //TODO set correct endpoints
      ),
      (result) => {
        if (result.success) {
          this.inputSubProject.thankYouMailSent = true;
          this.snackService.showSuccess('Bedankingsmail succesvol verzonden');
          this.dialogRef.close(true);
        }
        this.sending = false;
      },
      (err) => {
        this.sending = false;
      }
    );
  }

  canSendMail(): boolean {
    if (this.selectedContacts == null || this.selectedContacts.length === 0) {
      return true;
    }
    if (
      this.selectedContacts.some(
        (c) => c.emails == null || c.emails.length === 0
      )
    ) {
      this.snackService.showWarning(
        'Gelieve enkel ontvangers te selecteren die een e-mailadres hebben'
      );
      return false;
    }
    if (
      this.assetOptions != null &&
      this.assetOptions.length > 0 &&
      this.selectedAssets.length === 0
    ) {
      this.snackService.showWarning('Gelieve minstens één foto te selecteren');
      return false;
    }
    return true;
  }
}

const concat = (x, y) => x.concat(y);
